import { ReactElement, ReactNode, useCallback } from "react";
import { Article, useDataSource } from "../../DataSource";
import { useCSVDownloader } from "react-papaparse";
import { filterAndMap } from "../../core/utils";

const buttonStyles = {
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  appearance: "none",
  outline: "2px solid transparent",
  outlineOffset: "2px",
  lineHeight: "1.2",
  borderRadius: "var(--chakra-radii-md)",
  fontWeight: "var(--chakra-fontWeights-semibold)",
  height: "var(--chakra-sizes-8)",
  minWidth: "var(--chakra-sizes-8)",
  fontSize: "var(--chakra-fontSizes-sm)",
  paddingInlineStart: "var(--chakra-space-3)",
  paddingInlineEnd: "var(--chakra-space-3)",
  border: "1px solid",
  borderColor: "var(--chakra-colors-gray-200)",
  color: "var(--chakra-colors-gray-800)",
};

interface HeatmapDownloadButtonProps {
  xAxis: string;
  yAxis: string;
  articles: Article[];
  children?: ReactNode;
}

export default function HeatmapDownloadButton(
  props: HeatmapDownloadButtonProps
): ReactElement {
  const { xAxis, yAxis, articles, children } = props;

  const { csvHeader } = useDataSource();

  const { CSVDownloader, Type } = useCSVDownloader();

  const parseArticleData = useCallback(
    () =>
      [
        ...csvHeader,
        ...filterAndMap(articles, (article) =>
          article.data[xAxis] != null && article.data[yAxis] != null
            ? article.raw
            : null
        ),
      ].join("\n"),
    [articles, csvHeader, xAxis, yAxis]
  );

  return (
    <CSVDownloader
      filename="heatmap-data"
      type={Type.Button}
      data={parseArticleData}
      style={buttonStyles}
    >
      {children}
    </CSVDownloader>
  );
}
